import React, { ReactNode } from 'react';
import { Card } from '@/designSystem/Card';
import { AlertTriangle } from 'lucide-react';

interface NoAvailabilityMessageProps {
  filterControls?: ReactNode;
}

const NoAvailabilityMessage: React.FC<NoAvailabilityMessageProps> = ({
  filterControls,
}) => {
  return (
    <Card className="p-6 text-center">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="h-16 w-16 rounded-full bg-yellow-100 flex items-center justify-center">
          <AlertTriangle className="h-8 w-8 text-yellow-600" />
        </div>

        <h3 className="text-xl font-bold text-gray-800">No Data Available</h3>

        <p className="text-gray-600 max-w-lg">
          We couldn't find any property data with your current filter settings.
          This could be due to no availability.
        </p>

        {filterControls && (
          <div className="mt-2 p-4 bg-blue-50 rounded-lg w-full max-w-lg">
            <h4 className="font-medium text-blue-800 mb-2">Try adjusting the filters below or search for a different property:</h4>
            <div className="flex flex-wrap justify-center gap-4">
              {filterControls}
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default NoAvailabilityMessage;